// locales/en.js
export const en = {
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  today: 'Today',
  yesterday: 'Yesterday',

  welcome: 'Welcome',
  logout: 'Logout',
  settings: 'Settings',

  THEME: {
    DARK: 'Dark',
    LIGHT: 'Light',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Search...',
    SELECT_OPTION: 'Select an option...',
    SELECT_STATUS: 'Select status...',
    CHOOSE_STATUS: 'Choose status...',
    LOCATION: 'Enter a city, address, or place...',
    DESCRIPTION: 'Description of the incident',
    AI_DESCRIPTION:
      'Describe what happened, where, and when — e.g. There was a small fire in the electrical room near Balestier Road, Novena.',
    LOCATION_DESCRIPTION: 'Additional details about the location',
    VALIDATING: 'Validating...',
    GENERATING: 'Generating...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Search...',
    NO_MESSAGES_YET: 'No messages yet',
    IS_SPEAKING: 'is speaking...',
    ONLINE: 'online',
    OFFLINE: 'offline',
    TRANSCRIBING: 'Transcribing...',
    NO_CHAT_FOUND: 'No chats found',
    NO_CHAT_SELECTED_TITLE: 'No chat selected',
    NO_CHAT_SELECTED_DESCRIPTION: 'Select a user or group from the sidebar to start messaging',
    INPUT_PLACEHOLDER_DEFAULT: 'Write a message...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Add a caption...',
    IS_TALKING: 'is talking...',
    PTT_ACTIVE: 'PTT Active - Speaking...',
    PTT_LOCKED: 'PTT Locked - Click to release',
    PTT_SLIDE_HINT: 'Slide up to lock',
    PTT_RELEASE_AND_SEND: 'Release & Send',
    ATTACHED_FILES_TITLE: 'Attached Files',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Failed to transcribe audio',
    NO_CHAT_MESSAGE: 'No chat message',
    FALLBACK_MESSAGE: 'To start a chat, type your message or use the PTT/PTV feature.',
    INCOMING_VIDEO_CALL: 'Incoming PTV...',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    ERROR: 'Error:',
    NO_MESSAGES_FOUND_FOR: 'No messages found for',
    SYSTEM_MESSAGE: 'System message',
    GROUP: 'group',
    AUDIO: 'audio',
    VIDEO: 'video',
    FILE: 'file',
    ME: 'me',
    IMAGE: 'image',
    TEXT: 'text',
    CHAT: 'chat',
    NONE: 'none',
    PROFILE: 'profile',
    SEARCH: 'search',
    COMPLETED: 'completed',
    RESOLVED: 'resolved',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Unknown',
    THEM: 'them',
    HAS_ACCEPTED_THE_INCIDENT: 'has accepted the incident',
    INCIDENT_HAS_BEEN_UPDATED: 'Incident has been updated',
    INCIDENT_HAS_BEEN_RESOLVED: 'Incident has been resolved',
    YOU_HAVE_JOINED_THE_GROUP: 'You have joined the group',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'members',
    GROUP_MEMBERS_TITLE: 'Group Members',
    USERNAME_LABEL: 'Username',
    EMAIL_LABEL: 'Email',
    MEMBER_FALLBACK_NAME: 'Member',
    MEMBER_FALLBACK_ID: 'Member',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'PTT recording started for {{userName}}',
      STOP_RECORDING: 'PTT audio sent to {{userName}}',
      NO_AUDIO_DATA: 'No audio data received from SDK',
      TRANSCRIPTION_SUCCESS: 'Audio transcription completed',
      TRANSCRIPTION_FAILED: 'Transcription failed, sending audio without text',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'en',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Search in',
    YOUR_PROFILE: 'Your Profile',
    VIEW_PROFILE: 'View Profile',
    PIN_CHAT: 'Pin Chat',
    UNPIN_CHAT: 'Unpin Chat',
    MUTE_CHAT: 'Mute Chat',
    UNMUTE_CHAT: 'Unmute Chat',
  },

  DASHBOARD: {
    INCIDENTS: 'incidents',
    INCIDENTS_NO_DATA: 'To create an incident, click "+ Create Incident" button',
    GEOFENCES: 'geofences',
    MAP_FEATURES: 'Map Features',
    RESPONDERS: 'responders',
    RESPONDERS_NO_DATA: 'No responders found.',
    CHAT: 'chat',
    ALERTS: 'alerts',
    ALERTS_NO_DATA: 'No alerts generated by the system.',
    UPDATES: 'updates',
    UPDATES_NO_DATA: 'No updates on the incident or responders.',
    NEW_MESSAGE_FROM: 'New message from',
    INCIDENT_UPDATED_BY: 'Incident updated by',
    NEW_INCIDENT_CREATED_BY: 'New Incident created by',
    PROFILE: 'profile',
    SUMMARY: 'summary',
    GENERATING_SUMMARY: 'generating summary...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Incident name',
    INCIDENT_TYPE: 'Incident type',
    ASSIGNEES: 'assignee(s)',
    SEVERITY: 'severity',
    STATUS: 'status',
    STATUS_HISTORY: 'Status History',
    SHOW: 'Show',
    SHOW_LESS: 'Show less',
    MORE: 'more',
    PTT: 'PTT',
    LOCATION: 'location',
    SEVERITY_CRITICAL: 'critical',
    SEVERITY_HIGH: 'high',
    SEVERITY_MEDIUM: 'medium',
    SEVERITY_LOW: 'low',
    SEVERITY_MINIMAL: 'minimal',
    REPORTED_DATE_TIME: 'Reported Date and Time',
    REPORTED_NAME: 'Reported Name',
    DESCRIPTION: 'description',
    RESPONDERS: 'responder(s)',
    ATTACHMENTS: 'attachments',
    LOCATION_DESCRIPTION: 'location description',
    NO_RESPONDERS_ASSIGNED: 'No Responders Assigned for the incident.',
    CREATE_INCIDENT: 'Create Incident',
    EDIT_INCIDENT: 'Edit Incident',
    SELECT_RESPONDERS: 'Select Responders',
    COMPLETE: 'Complete',
    CANCEL: 'Cancel',
    SAVE: 'Save changes',
    NO: 'No',
    DATA_FOUND: 'Data Found',
    NO_OPTIONS: 'No options available',
    AI_ASSISTANCE: 'AI Assistance',
  },
  TAB_KEYS: {
    ALL: 'all',
    UNREAD: 'unread',
    ACTIVE: 'active',
    CLOSED: 'closed',
    AVAILABLE: 'available',
    OFFLINE: 'offline',
    TAB_VALUE_UNACKNOWLEDGED: 'unacknowledged',
    TAB_VALUE_CREATED: 'created',
    TAB_VALUE_PROGRESS: 'progress',
    TAB_VALUE_RESOLVED: 'resolved',
  },

  UPDATES_PANEL: {
    UPDATES: 'Updates',
    MARK_AS_READ: 'Mark all as Read',
    ALL: 'All',
    UNREAD: 'Unread',
    ALL_KEY: 'all',
    UNREAD_KEY: 'unread',
    NO_NOTIFICATIONS: 'No notifications',
    NO_UNREAD_NOTIFICATIONS: 'No unread notifications',
    UPDATE_STATUS: 'Update Status:',

    // Notification titles
    NEW_INCIDENT_TITLE: 'New Incident',
    UPDATE_TITLE: 'Update',

    CREATED_AT: 'created at',

    // Status labels
    STATUS_CLOSED: 'Closed',
    STATUS_IN_PROGRESS: 'In Progress',

    // Change descriptions
    STATUS_CHANGE: 'Status',
    SEVERITY_CHANGE: 'Severity',
    TYPE_CHANGE: 'Type',
    DESCRIPTION_UPDATED: 'Description updated',
    RESPONDERS_ADDED: 'responder(s) added',
    RESPONDERS_REMOVED: 'responder(s) removed',
    RESPONDERS_UPDATED: 'Responders updated',
    LOCATION_CHANGED: 'Location changed',
    UPDATED_DEFAULT: 'Updated',

    // Time
    UNKNOWN: 'Unknown',
    JUST_NOW: 'just now',
    MINUTES_AGO: '{{count}} min ago',
    MINUTES_AGO_plural: '{{count}} mins ago',
    HOURS_AGO: '{{count}} hour ago',
    HOURS_AGO_plural: '{{count}} hours ago',
    DAYS_AGO: '{{count}} day ago',
    DAYS_AGO_plural: '{{count}} days ago',

    // Default values
    DEFAULT_TYPE: 'Incident',
    UNKNOWN_LOCATION: 'Unknown location',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Incident Type',
      REPORTEDDATE: 'Reported Date',
      SEVERITY: 'Severity',
      STATUS: 'Status',
      RESPONDERS: 'Responders',
      NO_RESPONDERS: 'No responders available',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Incidents',
      MORE: 'more...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'View Mode',
      DEFAULT: 'Default',
      SATELLITE: 'Satellite',
      FILTER_BY: 'Filter By',
      ALL: 'all',
      ACTIVE: 'Active',
      COMPLETED: 'Completed',
      RESPONDERS: 'Responders',
      AVAILABLE: 'available',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'No',
    DATA_FOUND: 'Data Found',
    CREATE_INCIDENT: 'Create Incident',
    NO_AVAILABLE_RESPONDER_FOUND: 'No available responder found',
  },

  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Microphone Access Required',
      DESCRIPTION: 'This application needs access to your microphone to function properly.',
      INSTRUCTION: 'Please grant microphone permission to continue using the app.',
      BUTTON_LABEL: 'Grant Microphone Permission',
    },
    CAMERA: {
      TITLE: 'Camera Access Required',
      DESCRIPTION: 'This application needs access to your camera to function properly.',
      INSTRUCTION: 'Please grant camera permission to continue using the app.',
      BUTTON_LABEL: 'Grant Camera Permission',
    },
    NOTIFICATIONS: {
      TITLE: 'Notification Permission Required',
      DESCRIPTION: 'This application needs permission to send you notifications.',
      INSTRUCTION: 'Please grant notification permission to continue using the app.',
      BUTTON_LABEL: 'Grant Notification Permission',
    },
    GEOLOCATION: {
      TITLE: 'Location Access Required',
      DESCRIPTION: 'This application needs access to your location to function properly.',
      INSTRUCTION: 'Please grant location permission to continue using the app.',
      BUTTON_LABEL: 'Grant Location Permission',
    },
    HEADINGS: {
      WHAT_TO_DO: 'What you need to do:',
      ADDITIONAL_REQUIRED: 'Additional permissions required',
      GENERIC_PERMISSION_TITLE: 'Permission Required',
      GENERIC_DESCRIPTION: 'This application requires additional permissions to function properly.',
      GENERIC_INSTRUCTION: 'Please grant the required permissions to continue.',
    },
    DEFAULT_BUTTON_LABEL: 'Grant Permission',
  },

  SETTINGS: {
    TITLE: 'Settings',
    SUBTITLE: 'Manage your language and translation preferences',
    LANGUAGE_DISPLAY: 'Display Language',
    AUTO_TRANSLATE_TITLE: 'Enable Auto-Translate',
    AUTO_TRANSLATE_DESCRIPTION: 'Automatically translate incoming messages to your selected language.',
    SAVE_BUTTON: 'Save',
    SELECT_PLACEHOLDER: 'Select an option...',
  },

  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'activated SOS alert',
    LOCATION_LABEL: 'Location',
    INCIDENT_LABEL: 'Incident',
    LAST_STATUS_LABEL: 'Last Status',
    ASSIST_BUTTON: 'Assist',
  },

  HEADER: {
    USERNAME: 'username',
    MODE: 'mode',
    SETTINGS: 'settings',
    LOG_OUT: 'log out',
    TITLE: 'Workspace',
  },

  ERRORS: {
    INVALID_CHAT_DATA: 'Invalid chat data',
    SUMMARY_GENERATION_FAILED: 'Summary generation failed:',
    FAILED_TO_GENERATE_SUMMARY: 'Failed to generate summary.',
    PLEASE_TRY_AGAIN: 'Please try again.',
    UNKNOWN: 'Unknown',
    IN_PROGRESS_STATUS_ERROR: 'At least one responder must be assigned when status is "Progress"',
    RESOLVED_STATUS_ERROR: 'At least one responder must be assigned before closing the incident',
    SELECT_ONE_RESPONDER_ERROR: 'Please select at least one responder',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Please wait before submitting again',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE: 'Incident creation service is unavailable. Please try again later.',
    NO_CHANGES_TO_UPDATE: 'No changes to update',
    FAILED_TO_UPDATE_INCIDENT: 'Failed to update incident. Please check your connection and try again.',
    FAILED_TO_CREATE_INCIDENT: 'Failed to create incident. Please check your connection and try again.',
  },

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Medical' },
    { value: 'Car accident', label: 'Car accident' },
    { value: 'Fire', label: 'Fire' },
    { value: 'Patrol', label: 'Patrol' },
  ],

  // SEVERITY_VALUES used in Combobox component
  SEVERITY_VALUES: [
    { value: 4, label: 'Critical', dotColor: 'bg-icon-error' },
    { value: 3, label: 'High', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Medium', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Low', dotColor: 'bg-interactive' },
    { value: 0, label: 'Minimal', dotColor: 'bg-icon-muted' },
  ],

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Created' },
    { value: 'progress', label: 'Progress' },
    { value: 'resolved', label: 'Resolved' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Created' },
    { value: 'in_progress', label: 'Progress', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'Progress' },
    { value: 'resolved', label: 'Closed' },
  ],

  // STATUS_VALUES used in Combobox component
  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Created', disabled: true },
    { value: 'progress', label: 'Progress', disabled: true },
    { value: 'resolved', label: 'Closed', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Accepted' },
    { value: 'rejected', label: 'Declined' },
    { value: 'pending', label: 'Pending' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Not Started' },
    { value: 'on_the_way', label: 'On the way' },
    { value: 'reach_site', label: 'Reach site' },
    { value: 'enroute', label: 'Enroute' },
    { value: 'done', label: 'Done' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Unacknowledged' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Arrived at scene', label: 'Arrived at scene' },
    { value: 'On the way', label: 'On the way' },
    { value: 'Aborted', label: 'Aborted' },
    { value: 'Done', label: 'Done' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'Sun' },
    { value: 'Mon', label: 'Mon' },
    { value: 'Tue', label: 'Tue' },
    { value: 'Wed', label: 'Wed' },
    { value: 'Thu', label: 'Thu' },
    { value: 'Fri', label: 'Fri' },
    { value: 'Sat', label: 'Sat' },
  ],
};
